module.exports = __webpack_public_path__ + "static/media/techview-red.e8ddf1e9.svg";